// Wikimedia Commons photos with full TASL credits
export const STATIC_IMG = {
  "hero": {
    "src": "https://thumb.wikimedia.org/wikipedia/commons/thumb/e/e6/Norderney%2C_Nordsee_am_Oststrand_--_2016_--_4759.jpg/1280px-Norderney%2C_Nordsee_am_Oststrand_--_2016_--_4759.jpg",
    "credit": {
      "title": "Norderney, Nordsee am Oststrand -- 2016 -- 4759",
      "author": "Dietmar Rabich",
      "license": "CC BY-SA 4.0",
      "license_url": "https://creativecommons.org/licenses/by-sa/4.0",
      "source_url": "https://commons.wikimedia.org/wiki/File:Norderney,_Nordsee_am_Oststrand_--_2016_--_4759.jpg",
      "source": "Wikimedia Commons",
      "changes": "verkleinert und zugeschnitten"
    }
  },
  "sea": {
    "src": "https://thumb.wikimedia.org/wikipedia/commons/thumb/f/f3/Norderney%2C_Nordsee_am_Oststrand_--_2016_--_5162.jpg/1280px-Norderney%2C_Nordsee_am_Oststrand_--_2016_--_5162.jpg",
    "credit": {
      "title": "Norderney, Nordsee am Oststrand -- 2016 -- 5162",
      "author": "Dietmar Rabich",
      "license": "CC BY-SA 4.0",
      "license_url": "https://creativecommons.org/licenses/by-sa/4.0",
      "source_url": "https://commons.wikimedia.org/wiki/File:Norderney,_Nordsee_am_Oststrand_--_2016_--_5162.jpg",
      "source": "Wikimedia Commons",
      "changes": "verkleinert und zugeschnitten"
    }
  },
  "lighthouse": {
    "src": "https://thumb.wikimedia.org/wikipedia/commons/thumb/8/83/Pilsum-LSG-Krummhoern--2022_05_msu-1.jpg/1280px-Pilsum-LSG-Krummhoern--2022_05_msu-1.jpg",
    "credit": {
      "title": "Pilsum-LSG-Krummhoern--2022 05 msu-1",
      "author": "Matthias Süßen",
      "license": "CC BY-SA 4.0",
      "license_url": "https://creativecommons.org/licenses/by-sa/4.0",
      "source_url": "https://commons.wikimedia.org/wiki/File:Pilsum-LSG-Krummhoern--2022_05_msu-1.jpg",
      "source": "Wikimedia Commons",
      "changes": "verkleinert und zugeschnitten"
    }
  }
};
